/* global BUILD_COMMIT_HASH, BUILD_BRANCH, COUNTRY, THEME */
import { version as uiLibraryVersion } from '@dc/ui-library/package.json';
import { version as dataLayerVersion } from '@dc/data-layer/package.json';
import { version as bundlesVersion } from '@codex-applications/bundles/package.json';

if (typeof window !== 'undefined') {
  if (!window.BUILD_INFO) {
    window.BUILD_INFO = {};
  }

  window.BUILD_INFO.FO_SITE_UI = {
    BRANCH: BUILD_BRANCH,
    COMMIT_HASH: BUILD_COMMIT_HASH,
    COUNTRY: COUNTRY,
    THEME: THEME,
    UI_LIBRARY_VERSION: uiLibraryVersion,
    DATA_LAYER_VERSION: dataLayerVersion,
    CODEX_APPLICATIONS_BUNDLES_VERSION: bundlesVersion
  };
}
